import { render, staticRenderFns } from "./closures.vue?vue&type=template&id=0ad0b75f&"
import script from "./closures.vue?vue&type=script&lang=js&"
export * from "./closures.vue?vue&type=script&lang=js&"
import style0 from "./closures.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports